import React from 'react';
import Plot from 'react-plotly.js';


export default function ExpirationGraph(props) {
    const products = props
    var dateNow = new Date().getTime()
    var timestamp = new Date(dateNow + (120 * 24 * 60 * 60 * 1000))
    return (
        <div className="ContainerGraph">
            <Plot
                data={[{
                    type: 'bar',
                    x: products.map((e) => (((new Date(e.date)).getTime()) < timestamp && ((new Date(e.date)).getTime()) > dateNow ? e.date : null)),
                    // x: products.map((e) => (e.date)),
                    y: products.map((e) => (e.licenses_to_expirate)),
                }]}
                layout={{
                    width: 650,
                    height: 500,
                    title: 'Licenças que irão expirar em breve (120 days)',
                    'xaxis': { 'tickformat': '%b-%y', rangemode: 'tozero', autorange: true },
                    font: {
                        family: '"Roboto","Helvetica","Arial",sans-serif',
                        size: 13,
                        color: '#7f7f7f'
                    },
                }}
                config={{
                    displayModeBar: false,
                    staticPlot: false,
                    rangemode:'auto'
                }}
            />
        </div>
    )
}